import util from '@bmp-vue/core/api/util'
const controller = 'Pixmoney'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
})
